import styled from "styled-components";

export const OrderInfoWrap = styled.div`
  padding: 20px;
  background: white;
  border-radius: 2px;
  margin-bottom: 20px;

  & > div:last-child {
    margin-top: 1em;
  }
`;
